import Experience from '@root/agents.joinroot.com/src/models/experiences';
import ServerUtils from '@root/core/src/api/server-utils';

// attribute the quote to the agent_id
export const attributeQuoteToAgent = (quote_id, agent_id) => ServerUtils.authenticatedPatch(
  `/agent_api/cp_api_proxy/v3/quoting/quote/${quote_id}`,
  {
    body: {
      agent: {
        id: agent_id,
      },
    },
    expectedResponse: [200, 201],
  });

// create a bridge link for a given quote id
// also set the utm_source + auth_source
export const createAgencyPlatformBridgeLink = async (quote_id) => {
  const result = await ServerUtils.authenticatedPost(
    `/agent_api/cp_api_proxy/v3/quoting/quote/${quote_id}/bridge_link`,
    {
      body: {
        quote_id,
        attributionParameters: {
          utm_source: 'legacy_rap',
          auth_source: 'legacy_rap',
        },
      },
      expectedResponse: [200, 201],
    }
  );

  const url = new URL(result.data.url);
  url.searchParams.set('utm_source', 'legacy_rap');
  url.searchParams.set('auth_source', 'legacy_rap');
  return url.toString();
};

const appendExperienceParam = (urlString, experience) => {
  const url = new URL(urlString);
  url.searchParams.set('experience', experience);
  return url.toString();
};

const appendQuoteSourceParam = (urlString, quoteSource) => {
  if (!quoteSource) {
    return urlString;
  }
  const url = new URL(urlString);
  url.searchParams.set('quote_source', quoteSource);
  return url.toString();
};

const appendAgencyPlatformBridgeLinkParams = (
  urlString,
  quoteSource,
  experience = Experience.AgentCustomerOnboarding
) => appendExperienceParam(appendQuoteSourceParam(urlString, quoteSource), experience);

const targetExperienceFor = (experience) => experience === Experience.AgentEndorsement
  ? Experience.AgentEndorsement
  : Experience.AgentCustomerOnboarding;

export const attributeQuoteToAgentAndCreateBridgeLink = async (
  quote_id,
  agent_id,
  quoteSource,
  experience = Experience.AgentCustomerOnboarding
) => {
  await attributeQuoteToAgent(quote_id, agent_id);
  const url = await createAgencyPlatformBridgeLink(quote_id);
  return appendAgencyPlatformBridgeLinkParams(url, quoteSource, experience);
};

export const createBridgeLinkWithExperienceBasedAttribution = async (
  quote_id,
  agent_id,
  quoteSource,
  experience = Experience.AgentCustomerOnboarding
) => {
  const targetExperience = targetExperienceFor(experience);

  if (targetExperience === Experience.AgentEndorsement) {
    const url = await createAgencyPlatformBridgeLink(quote_id);
    return appendAgencyPlatformBridgeLinkParams(url, quoteSource, targetExperience);
  }

  return attributeQuoteToAgentAndCreateBridgeLink(quote_id, agent_id, quoteSource, targetExperience);
};
